import React, { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import api from '../../../../middleware/api';
import PortalModal from '../../../Common/Modal/PortalModal';
import { formatDefaultConfigurationToAddCapsule } from '../../../../utils/capsule_configuration.utils';
import { useCapsuleConfigurator } from '../../../../context/CapsuleConfiguratorContext';
const UpdateBatchSensibilityModal = React.forwardRef(({ selectedItem, selectedConfigurationId, defaultCapsule, setCapsuleConfiguration }, ref) => {
    const [sensibility, setSensibility] = useState('');
    const { updateConfigurationContent, setConfigurationSelection, updateConfigurationIsValid } = useCapsuleConfigurator();

    const handleSensibilityChange = useCallback((value) => {
        setSensibility(value);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            console.log('selectedItem', selectedItem)

            const response = await api.put(`/capsules/configurations/update/batch/sensibility-dilution/${selectedConfigurationId}`, {
                mixtureIds: selectedItem,
                sensibility: sensibility || null,
                dilution: null
            });
            console.log(response.data)
            if (response.status === 200) {
                const updatedCapsule = formatDefaultConfigurationToAddCapsule(response.data.configuration, defaultCapsule.name, defaultCapsule.id);
                console.log('updatedCapsule', updatedCapsule)
                setCapsuleConfiguration(updatedCapsule);
                updateConfigurationContent(updatedCapsule.content)
                updateConfigurationIsValid(response.data.isValid)
                setConfigurationSelection({});
                toast.success('La sensibilité a été mise à jour avec succès');
            }
        } catch (e) {
            console.error(e);
            toast.error('Une erreur s\'est produite lors de la mise à jour de la sensibilité');
        }
        ref.current?.hideModal();
    }

    return (
        <PortalModal ref={ref}>
            <form onSubmit={handleSubmit} className='p-4'>
                <h1 className='text-xl font-bold mb-4'>Appliquer la sensibilité au mélanges sélectionnés</h1>

                <div className='flex flex-row flex-wrap gap-y-4 mt-4'>
                    <select
                        className='form-select border border-gray-300 rounded-md p-2'
                        onChange={(e) => handleSensibilityChange(e.target.value)}
                        value={sensibility}
                    >
                        <option value=''>Sensibilité</option>
                        {[0, 1, 2, 3, 4, 5].map(value => (
                            <option key={value} value={value.toString()}>{value}</option>
                        ))}
                    </select>
                </div>
                <div className='flex flex-row flex-wrap justify-center gap-4 mt-4'>
                    <button type="submit" className='btn btn-primary max-w-24 min-w-24 rounded-md p-2 '>
                        Appliquer
                    </button>
                    <button
                        type="button"
                        className='btn btn-error text-white max-w-24 min-w-24 rounded-md p-2 '
                        onClick={() => ref.current?.hideModal()}
                    >
                        Annuler
                    </button>
                </div>
            </form>
        </PortalModal>
    );
});

export default UpdateBatchSensibilityModal; 